import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import type { Response } from 'express';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs';
import { RESPONSE } from '../express.token';

type TimingResponse = {
    startTime: (name: string, description: string) => void;
    endTime: (name: string) => void;
} & Response;

export function withTiming(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const response = inject(RESPONSE, { optional: true }) as TimingResponse;
    if (!response) {
        return next(request);
    }
    const parts = extractPartsOfUrl(request.urlWithParams);
    let name = parts.pathname;
    if (parts.queryParams) {
        name += `?${parts.queryParams}`;
    }
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    name = name.replace(/\//g, '-').slice(1);
    response.startTime(name, name);
    return next(request).pipe(
        finalize(() => {
            response.endTime(name);
        }),
    );
}

export function extractPartsOfUrl(url: string): {
    protocol: string;
    host: string;
    pathname: string;
    port: number | null;
    queryParams: string;
} {
    const parsedUrl = new URL(url);
    const port = parsedUrl.port ? Number.parseInt(parsedUrl.port) : null;

    return {
        protocol: parsedUrl.protocol,
        host: parsedUrl.host.replace(`:${port}`, ''),
        pathname: parsedUrl.pathname,
        queryParams: parsedUrl.searchParams ? parsedUrl.searchParams.toString() : '',
        port,
    };
}
